export default [
  {
    path: '/',
    name: 'default',
    meta: {
      authRequired: true,
      track:true
    },
    component: () => import('./views/packinglist/default'),
  },
  {
    path: '/configuration/organisation',
    name: 'organisation',
    meta: {
      authRequired: true,
      rolesRequired: "admin"
    },
    component: () => import('./views/configuration/organisation/default'),
  },    
  {
    path: '/configuration/users',
    name: 'users',
    meta: {
      authRequired: true,
      rolesRequired: "admin"
    },
    component: () => import('./views/configuration/users/default'),
  },     
  {
    path: '/configuration/users/:userId',
    name: 'editUser',
    meta: {
      authRequired: true,
      rolesRequired: "admin"
    },
    component: () => import('./views/configuration/users/userDetail'),
  },
/*   {
    path: '/products',
    name: 'productsByPacking',
    meta: {
      authRequired: true,
      track: true
    },
    component: () => import('./views/products/byPacking'),
  }, */
  {
    path: '/products',
    name: 'productsByPacking',
    meta: {
      authRequired: true,
      track: true
    },
    component: () => import('./views/products/byPackingV2'),
  },
  {
    path: '/workorderproducts/:workOrderPublicId',
    name: 'workOrderProducts',
    meta: {
      authRequired: true,
      track: true
    },
    component: () => import('./views/products/byPackingV2'),
  },
  {
    path: '/packingproducts/:packingId',
    name: 'packingProducts',
    meta: {
      authRequired: true,
      track: true
    },
    component: () => import('./views/products/byPackingV2'),
  },
  {
    path: '/:workorderid/',
    name: 'products',
    meta: {
      authRequired: true,
      track:true
    },
    props: route => ({query: route.query.packing}),
    component: () => import('./views/products/default'),
  },
]
